/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * * `without_influence` - bez vlivu kulturního prostředí nebo jiných životních podmínek * `evaluation_of_seven_key_areas` - Hodnocení sedmi sledovaných oblastí / faktorů
 */
export type SocialCategoryDisadvantageA61Enum = 'without_influence' | 'evaluation_of_seven_key_areas';

export const SocialCategoryDisadvantageA61Enum = {
    WithoutInfluence: 'without_influence' as SocialCategoryDisadvantageA61Enum,
    EvaluationOfSevenKeyAreas: 'evaluation_of_seven_key_areas' as SocialCategoryDisadvantageA61Enum
};